import {Box, Tab, Tabs} from '@mui/material'
import {useAuth} from 'src/contexts/AuthContext'
import {CameraConfigHeaderProps} from './CameraTabsHeaderProps'
import {useEffect, useState} from 'react'
import {useSearchParams} from 'react-router-dom'

export function CameraTabsHeader(cameraTabsHeaderProps: CameraConfigHeaderProps) {
  const {tab, setTab} = cameraTabsHeaderProps
  const {user} = useAuth()
  const [searchParams] = useSearchParams()

  const [isEditing, setIsEditing] = useState(false)

  useEffect(() => {
    const tabParam = searchParams.get('mode')

    if (tabParam && tabParam === 'update') setIsEditing(true)
    else setIsEditing(false)
  }, [searchParams])

  const userHasEditConfigPermission = user.permissions.includes('camera-parameter-config:update')

  return (
    <Box sx={styles.tabHeader}>
      <Tabs value={tab} onChange={(_, newTab) => setTab(newTab)} scrollButtons='auto' aria-label='scrollable auto tabs example'>
        <Tab label='Dados Gerais' style={styles.tab} disabled={isEditing} />
        <Tab label='Conexão' style={styles.tab} disabled={isEditing} />
        <Tab label='Barreiras' style={styles.tab} disabled={isEditing} />
        <Tab label='Detecções' style={styles.tab} disabled={isEditing} />
        <Tab label='Arme/Desarme' style={styles.tab} disabled={isEditing} />
        <Tab label='Histórico' style={styles.tab} disabled={isEditing} />
        <Tab label='Configurações Avançadas' style={styles.tab} disabled={isEditing} {...(!userHasEditConfigPermission ? {sx: {display: 'none'}} : {})} />
      </Tabs>
    </Box>
  )
}

const styles = {
  tabHeader: {
    justifyContent: 'center',
    display: 'flex',
  },
  tab: {
    fontFamily: 'Inter',
    fontSize: '13px',
  },
}
